import * as tslib_1 from "tslib";
import { HttpClient, HttpParams } from '@angular/common/http';
import { switchMap, map } from 'rxjs/operators';
import { environment } from 'environment/environment';
import { ApiAbstractService } from './api-abstract.service';
import { CustomerService } from './customer.service';
var RecordService = /** @class */ (function (_super) {
    tslib_1.__extends(RecordService, _super);
    function RecordService(httpClient, customerService) {
        var _this = _super.call(this, environment.API_BASE) || this;
        _this.httpClient = httpClient;
        _this.customerService = customerService;
        _this.apiBase = environment.API_BASE;
        return _this;
    }
    RecordService.prototype.getCustomerRecord = function (customerId) {
        var _this = this;
        return this.customerService.getCustomerCrps({
            customerId: customerId,
            limit: 1,
            primary: true
        }).pipe(switchMap(function (crps) {
            var customerCrp = crps.results[0];
            if (customerCrp.recordType === 'INDIVIDUAL') {
                return _this.getIndividualRecord(customerCrp.record);
            }
            else {
                return _this.getCorporateRecord(customerCrp.record);
            }
        }), map(function (record) {
            return record;
        }));
    };
    RecordService.prototype.getRecords = function (name) {
        if (name === void 0) { name = ''; }
        return this.httpClient.get(this.apiBase + "/api/records/?search=" + name);
    };
    RecordService.prototype.getIndividualRecords = function (payload) {
        return this.httpClient.get(this.buildUrl("/api/individual_records/", payload));
    };
    RecordService.prototype.getCorporateRecords = function (payload) {
        return this.httpClient.get(this.buildUrl("/api/corporate_records/", payload));
    };
    RecordService.prototype.getRecord = function (recordId) {
        return this.httpClient.get(this.apiBase + "/api/records/" + recordId + "/");
    };
    RecordService.prototype.getRecordByReferenceId = function (referenceId) {
        return this.httpClient.get(this.apiBase + "/api/records/?reference_id=" + referenceId);
    };
    RecordService.prototype.getIndividualRecord = function (recordId) {
        return this.httpClient.get(this.apiBase + "/api/individual_records/" + recordId + "/");
    };
    RecordService.prototype.getCorporateRecord = function (recordId) {
        return this.httpClient.get(this.apiBase + "/api/corporate_records/" + recordId + "/");
    };
    RecordService.prototype.createIndividualRecord = function (newIndividualRecord) {
        return this.httpClient.post(this.apiBase + "/api/individual_records/", newIndividualRecord);
    };
    RecordService.prototype.createCorporateRecord = function (newCorporateRecord) {
        return this.httpClient.post(this.apiBase + "/api/corporate_records/", newCorporateRecord);
    };
    RecordService.prototype.updateIndividualRecord = function (recordId, newIndividualRecord) {
        return this.httpClient.put(this.apiBase + "/api/individual_records/" + recordId + "/", newIndividualRecord);
    };
    RecordService.prototype.updateCorporateRecord = function (recordId, newCorporateRecord) {
        return this.httpClient.put(this.apiBase + "/api/corporate_records/" + recordId + "/", newCorporateRecord);
    };
    RecordService.prototype.getCountries = function (name) {
        if (name === void 0) { name = ''; }
        return this.httpClient.get(this.apiBase + "/api/records/countries/?search=" + name);
    };
    RecordService.prototype.getSourceOfFunds = function () {
        return this.httpClient.get(this.apiBase + "/api/records/source_of_funds/");
    };
    RecordService.prototype.getSSIC = function (name) {
        if (name === void 0) { name = ''; }
        return this.httpClient.get(this.apiBase + "/api/records/ssic/?search=" + name);
    };
    RecordService.prototype.getSSICMigration = function (name) {
        if (name === void 0) { name = ''; }
        return this.httpClient.get(this.apiBase + "/api/records/ssic/?search=" + name + "&legacy=true");
    };
    RecordService.prototype.getSSOC = function (name) {
        if (name === void 0) { name = ''; }
        return this.httpClient.get(this.apiBase + "/api/individual_records/ssoc/?search=" + name);
    };
    RecordService.prototype.getSSOCMigration = function (name) {
        if (name === void 0) { name = ''; }
        return this.httpClient.get(this.apiBase + "/api/individual_records/ssoc/?search=" + name + "&legacy=true");
    };
    RecordService.prototype.getTitles = function (name) {
        if (name === void 0) { name = ''; }
        return this.httpClient.get(this.apiBase + "/api/individual_records/titles/?search=" + name);
    };
    RecordService.prototype.getIDTypes = function (name) {
        if (name === void 0) { name = ''; }
        return this.httpClient.get(this.apiBase + "/api/individual_records/id_types/?search=" + name);
    };
    RecordService.prototype.getEntityTypes = function (name) {
        if (name === void 0) { name = ''; }
        return this.httpClient.get(this.apiBase + "/api/corporate_records/entity_types/?search=" + name);
    };
    RecordService.prototype.getOwnershipLayers = function () {
        return this.httpClient.get(this.apiBase + "/api/corporate_records/ownership_layers/");
    };
    RecordService.prototype.getRoles = function () {
        return this.httpClient.get(this.apiBase + "/api/crps/roles/");
    };
    RecordService.prototype.isIncorporated = function (recordId) {
        return this.getCorporateRecord(recordId).pipe(map(function (record) { return record.isIncorporated; }));
    };
    RecordService.prototype.getOtherData = function (getOtherDataReqBody) {
        var params = new HttpParams();
        var url = this.apiBase + '/api/others_data/';
        if (getOtherDataReqBody) {
            var reqBodyEntries = Object.entries(getOtherDataReqBody);
            reqBodyEntries.forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (value !== undefined) {
                    params = params.append(key, value);
                }
            });
        }
        return this.httpClient.get(url, { params: params });
    };
    RecordService.prototype.updateOtherData = function (updateOtherDataReqBody) {
        var url = this.apiBase + ("/api/others_data/" + updateOtherDataReqBody.otherDataId + "/");
        delete updateOtherDataReqBody.otherDataId;
        return this.httpClient.patch(url, updateOtherDataReqBody);
    };
    return RecordService;
}(ApiAbstractService));
export { RecordService };
